import { axiosInstance } from './axiosInstance';


export const declarationData = async (selectedYear) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/dashboard/declaration-data/${selectedYear}`);
        return response;
    } catch (error) {
        return error;
    }
};